export default {"src":"/_next/static/media/offering-divider.9f5bc001.svg","height":138,"width":962};